import { getClassPropName } from "./get-class-prop-name.qwik.mjs";
import { getStyle } from "./get-style.qwik.mjs";
import { transformBlockProperties } from "./transform-block-properties.qwik.mjs";
const extractRelevantRootBlockProperties = (block) => {
  return {
    href: block.href
  };
};
function getBlockProperties({ block, context }) {
  var _a;
  const properties = {
    ...extractRelevantRootBlockProperties(block),
    ...block.properties,
    "builder-id": block.id,
    style: getStyle({
      block,
      context
    }),
    [getClassPropName()]: [
      block.id,
      "builder-block",
      block.class,
      (_a = block.properties) == null ? void 0 : _a.class
    ].filter(Boolean).join(" ")
  };
  return transformBlockProperties({
    properties,
    context,
    block
  });
}
export {
  getBlockProperties
};
